export const getMenuProductId = (product) => {
  if (typeof product === 'string') return product;
  return product?.productId || product?.id;
};

export const isMenuProductActive = (productStatus, productId) => {
  if (!productId) return true;
  return productStatus?.[productId] !== false;
};

const addProductIds = (products = [], productIds) => {
  products.forEach((product) => {
    const productId = getMenuProductId(product);
    if (productId) productIds.add(productId);
  });
};

const addSubCategoryProductIds = (subCategoryId, subCategoriesById, productIds, visitedSubCategories) => {
  if (!subCategoryId || visitedSubCategories.has(subCategoryId)) return;

  visitedSubCategories.add(subCategoryId);

  const subCategory = subCategoriesById[subCategoryId];
  if (!subCategory) return;

  addProductIds(subCategory.products, productIds);

  (subCategory.subCategories || []).forEach((childSubCategoryId) => {
    addSubCategoryProductIds(childSubCategoryId, subCategoriesById, productIds, visitedSubCategories);
  });
};

export const collectMenuProductIds = (categoryIds = [], categories = [], subCategories = []) => {
  const categoriesById = {};
  const subCategoriesById = {};
  const productIds = new Set();
  const visitedSubCategories = new Set();

  categories.forEach((category) => {
    categoriesById[category.id] = category;
  });

  subCategories.forEach((subCategory) => {
    subCategoriesById[subCategory.id] = subCategory;
  });

  categoryIds.forEach((categoryId) => {
    const category = categoriesById[categoryId];
    if (!category) return;

    addProductIds(category.products, productIds);

    (category.subCategories || []).forEach((subCategoryId) => {
      addSubCategoryProductIds(subCategoryId, subCategoriesById, productIds, visitedSubCategories);
    });
  });

  return Array.from(productIds);
};

export const normalizeMenuProductStatus = (
  categoryIds = [],
  categories = [],
  subCategories = [],
  currentStatus = {},
) => {
  return collectMenuProductIds(categoryIds, categories, subCategories).reduce((acc, productId) => {
    if (!isMenuProductActive(currentStatus, productId)) acc[productId] = false;
    return acc;
  }, {});
};
